import { formatDate } from 'commons/utils/date'

import type { NDHistoryParamsApi } from './interface'

export const toNDHistoryParamsApi = (date: string): NDHistoryParamsApi => {
  const formattedDate = formatDate(date, 'MMYYYY', 'YYYY-MM')
  return {
    mesCotaFinal: formattedDate,
    mesCotaInicial: formattedDate,
  }
}
